// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__agH4f","icon":"holding-image_icon__ge_L8","holdingImageUnavailable":"holding-image_holdingImageUnavailable__XFySj"};